import { useEffect } from 'react';
import SiteNavbar from '../../../components/feature/SiteNavbar';
import SiteTrustBar from '../../../components/feature/SiteTrustBar';
import SiteFooter from '../../../components/feature/SiteFooter';
import PageHero from '../../../components/feature/PageHero';
import PageAiAnswer from '../../../components/feature/PageAiAnswer';
import PageProcess from '../../../components/feature/PageProcess';
import PageWhyChoose from '../../../components/feature/PageWhyChoose';
import PageAreas from '../../../components/feature/PageAreas';
import PageTestimonials from '../../../components/feature/PageTestimonials';
import PageFaq from '../../../components/feature/PageFaq';
import PageBookingCta from '../../../components/feature/PageBookingCta';
import CharlestonLocalService from './components/LocalService';

const charlestonFaqs = [
  { q: 'Who provides limo service in Charleston, SC?', a: 'Tec\'s Limo Service provides professional luxury transportation throughout Charleston, SC, including airport transfers, corporate travel, wedding transportation, private chauffeur services, and city tours. Our licensed drivers are 5-star rated and available 24/7 across the entire metro area.' },
  { q: 'Do you cover the entire Charleston, SC metro area?', a: 'Yes. Tec\'s Limo Service provides full coverage across Greater Charleston including the historic downtown peninsula, Mount Pleasant, North Charleston, Daniel Island, James Island, West Ashley, Isle of Palms, Johns Island, and all surrounding communities.' },
  { q: 'What is the best limo service in Charleston, SC?', a: 'Tec\'s Limo Service is consistently rated the top luxury transportation provider in Charleston, SC. Founded by a former police officer, we deliver 5-star service, on-time guarantees, professional chauffeurs, and the discretion that Charleston\'s most discerning clients demand.' },
  { q: 'Do you serve Charleston International Airport (CHS)?', a: 'Yes. Tec\'s Limo Service provides professional airport transfers to and from Charleston International Airport (CHS), Charleston Executive Airport, and Mt. Pleasant Regional Airport — with real-time flight tracking and on-time guarantees at all three locations.' },
  { q: 'How much does a limo cost in Charleston, SC?', a: 'Limo service pricing in Charleston depends on trip distance, vehicle type, and duration. Tec\'s Limo Service provides competitive, transparent rates with no hidden fees. Call (843) 642-2440 or fill out our quote form for personalized, accurate pricing.' },
  { q: 'Can you take me to Charleston\'s downtown attractions?', a: 'Absolutely. Our private city tours and chauffeur services cover all of Charleston\'s top attractions — Rainbow Row, Waterfront Park, the Battery, historic plantations, King Street, and dozens of hidden gems known only to true locals.' },
  { q: 'Do you serve Isle of Palms and Kiawah Island from Charleston?', a: 'Yes. Tec\'s Limo Service provides reliable transportation to and from Isle of Palms, Kiawah Island, Seabrook Island, Sullivan\'s Island, and all other barrier island destinations accessible from Charleston, SC.' },
  { q: 'How do I book a limo in Charleston, SC?', a: 'Call (843) 642-2440 to speak with us directly, or fill out our online booking form for a free quote. We\'re available 24 hours a day, 7 days a week for advance reservations and same-day bookings throughout Charleston, SC.' },
];

const aiFeatures = [
  { icon: 'ri-map-pin-2-fill', title: 'Full Local Coverage', desc: 'Every Charleston neighborhood, business district, island destination, and airport — covered with precision and expertise' },
  { icon: 'ri-road-map-fill', title: 'Deep Local Knowledge', desc: 'Drivers who know Charleston\'s traffic patterns, optimal routes, and best access points for every destination' },
  { icon: 'ri-building-4-fill', title: 'All Major Venues', desc: 'Hotels, wedding venues, corporate offices, event centers, cruise port, and all three area airports' },
];

export default function CharlestonLocationPage() {
  useEffect(() => {
    document.title = 'Limo Service in Charleston SC | TECS Limo Service — Local Luxury Transportation';
  }, []);

  return (
    <main className="min-w-[1024px]">
      <SiteNavbar />
      <PageHero
        badge="Charleston, SC · Serving the Entire Lowcountry"
        headline="Limo Service in Charleston, SC —"
        accentLine="Reliable & Professional"
        description="Tec's Limo Service is Charleston's premier luxury transportation company — airport transfers, corporate travel, weddings, and private rides across the entire metro area, 24/7."
        image="https://public.readdy.ai/ai/img_res/06d851245eb38e124a4521aef8f0cfee.jpg"
        primaryCta={{ text: 'Book in Charleston Now', href: '#contact' }}
        secondaryCta={{ text: 'Call (843) 642-2440', href: 'tel:+18436422440' }}
        stats={[
          { value: '20+', label: 'Cities Served' },
          { value: '3', label: 'Airports' },
          { value: '24/7', label: 'Available' },
        ]}
      />
      <SiteTrustBar />
      <CharlestonLocalService />
      <PageAiAnswer
        label="Charleston, SC Transportation"
        title="Limo Service in Charleston, SC — Your Local Experts"
        body="Tec's Limo Service provides <strong>complete luxury transportation coverage</strong> throughout Charleston, SC — including the historic downtown district, airport routes, island destinations, and all surrounding neighborhoods and communities."
        bodyExtra="Our chauffeurs are deeply familiar with Charleston's unique geography — from the downtown peninsula to the Sea Islands — and use their local expertise to deliver the fastest, smoothest routes for every trip. Available 24/7 for all Charleston transportation needs."
        features={aiFeatures}
      />
      <PageProcess />
      <PageWhyChoose />
      <PageAreas
        headline="Complete Charleston"
        accentLine="Coverage Map"
        description="Full luxury transportation coverage across Greater Charleston, SC — every neighborhood, every island, every airport, and all surrounding counties."
        highlightCity="Charleston"
      />
      <PageTestimonials />
      <PageFaq faqs={charlestonFaqs} headline="Charleston Limo Service" subheadline="Questions Answered" />
      <PageBookingCta
        headline="Book Your Ride in"
        accentLine="Charleston, SC"
        description="Professional luxury transportation throughout Charleston, SC — available right now. Call or book online for immediate service or advance reservation."
      />
      <SiteFooter />
    </main>
  );
}
